import { render } from "./verify-email.page.vue?vue&type=template&id=4d7846ec&ts=true"
import script from "./verify-email.page.vue?vue&type=script&lang=ts"
export * from "./verify-email.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__